// Shared grid row height (px) for the entity list view and the generated child grids, so every
// grid has the same density. A bit tighter than MUI's compact default. Change here to retune all grids.
export const GRID_ROW_HEIGHT = 44;

// Shared DataGrid styling used by the entity list view and the generated child grids
// so they look identical. The row checkbox and the row-edit pencil (actions column) are
// toned down and hidden (opacity 0) until the row is hovered or the control is focused
// (keyboard); a checked box stays visible and tinted, matching the header select-all.
// Spread this into a DataGrid `sx` alongside any per-grid layout keys.
export const hoverRevealGridSx = {
  '& .MuiDataGrid-cellCheckbox .MuiCheckbox-root': {
    opacity: 0,
    transition: 'opacity 0.1s',
    color: 'action.disabled',
  },
  '& .MuiDataGrid-row:hover .MuiCheckbox-root': { opacity: 1 },
  '& .MuiDataGrid-cellCheckbox:focus-within .MuiCheckbox-root': { opacity: 1 },
  '& .MuiDataGrid-cellCheckbox .MuiCheckbox-root.Mui-checked': {
    opacity: 1,
    color: 'primary.main',
  },
  // The header select-all is toned down until it's actually in use.
  '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
    color: 'action.disabled',
  },
  '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.Mui-checked, & .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.MuiCheckbox-indeterminate':
    { color: 'primary.main' },
  // The row-edit pencil is hidden until the row is hovered or the action button is focused.
  '& .MuiDataGrid-actionsCell': {
    opacity: 0,
    transition: 'opacity 0.1s',
  },
  '& .MuiDataGrid-row:hover .MuiDataGrid-actionsCell': { opacity: 1 },
  '& .MuiDataGrid-actionsCell:focus-within': { opacity: 1 },
};
